module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/2e92c575703ab1fba5c6bf0e008a3f17.jpg";